import { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getMappedLinkedItems } from './utils/component-mapping-helpers';

export const my_account_placeholder = (entry: MEMBERSHIP_MODELS.MyAccountPlaceholder) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements } = entry;

  return {
    options: getMappedLinkedItems(elements?.options),
    interests: getMappedLinkedItems(elements?.interests)

  };
};

export default my_account_placeholder;